// extracted by mini-css-extract-plugin
export default {"submit":"ChangeComplex_submit__UxXhc","text":"ChangeComplex_text__4NyQV","complexLabel":"ChangeComplex_complexLabel__s-njE"};